<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-alert type="warning">
        <div slot="message">
          Note: Code is not duplicate / Mã không được trùng
        </div>
      </a-alert>
      <a-form-model
        layout="vertical"
        v-bind="{
          labelCol: { span: 24 },
          wrapperCol: { span: 24 },
        }"
        :rules="rules"
        ref="ruleForm"
        :model="form"
        style="margin-top: 20px;"
      >
        <a-form-model-item label="Code / Mã" prop="code">
          <a-input v-model="form.code" placeholder="Enter code..." />
        </a-form-model-item>
        <a-form-model-item label="Title / Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Enter title..." />
        </a-form-model-item>
        <a-form-model-item label="Weekday / Các ngày làm việc">
          <a-select
            mode="multiple"
            style="width: 100%;"
            :token-separators="[',']"
            v-model="form.dayInWeeks"
            placeholder="Select date"
          >
            <a-select-option v-for="i in dayOfWeeks" :key="i.key">
              {{ i.Title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Start time / Thời gian bắt đầu">
          <a-time-picker
            placeholder="Select time"
            mode="time"
            format="HH:mm"
            style="width: 100%;"
            :show-time="{ format: 'HH:mm' }"
            :minuteStep="30"
            @change="
              (value) => {
                form.startTime = value;
                calDurationTime();
                resetTime('startTime');
              }
            "
            :value="
              form.startTime
                ? moment(moment(form.startTime).format('HH:mm'), 'HH:mm')
                : null
            "
          />
        </a-form-model-item>
        <a-form-model-item label="End time / Thời gian kết thúc">
          <a-time-picker
            :show-time="{ format: 'HH:mm' }"
            placeholder="Select time"
            mode="time"
            format="HH:mm"
            style="width: 100%;"
            :minuteStep="30"
            @change="
              (value) => {
                form.endTime = value;
                calDurationTime();
                resetTime('endTime');
              }
            "
            :value="
              form.endTime
                ? moment(moment(form.endTime).format('HH:mm'), 'HH:mm')
                : null
            "
          />
        </a-form-model-item>
        <a-form-model-item label="Start break time / Bắt đầu nghỉ giữa giờ">
          <a-time-picker
            placeholder="Select time..."
            :value="
              form.startBreakTime
                ? moment(moment(form.startBreakTime).format('HH:mm'), 'HH:mm')
                : null
            "
            style="width: 100%;"
            :show-time="{ format: 'HH:mm' }"
            mode="time"
            format="HH:mm"
            :disabledHours="disabledHoursStartBreakTime"
            popupClassName="top-time-picker"
            :hideDisabledOptions="true"
            :minuteStep="30"
            @change="
              (value) => {
                form.startBreakTime = value;
                resetTime('startBreakTime');
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item>
          <div slot="label">
            End breake time / Thời gian nghỉ giữa giờ:
            {{ form.durationBreakTime }} (Hour)
          </div>
          <a-slider
            v-model="form.durationBreakTime"
            :min="0"
            :max="8"
            :step="0.5"
          />
        </a-form-model-item>
        <a-form-model-item>
          <div slot="label">
            Duration / Tổng số giờ làm việc: {{ form.duration }}
          </div>
        </a-form-model-item>
        <a-form-model-item label="Payroll date / Ngày tính lương">
          <a-select
            v-model="form.makePayrollDate"
            allowClear
            showSearch
            placeholder="Select date"
          >
            <a-select-option v-for="i in 28" :key="i">
              {{ i }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Department / Phòng ban">
          <SelectDepartment
            v-model="form.departmentIds"
            :selectProps="{
              value: form.departmentIds,
              placeholder: 'Department',
              mode: 'multiple',
            }"
            :initialDatas="form.departments"
          />
        </a-form-model-item>
        <a-form-model-item label="Location / Địa điểm làm việc">
          <SelectBranchLocation
            v-model="form.branchLocationId"
            :selectProps="{
              value: form.branchLocationId,
              placeholder: 'Location',
            }"
            :initialDatas="form.branchLocation ? [form.branchLocation] : []"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-checkbox v-model="form.isOvertime">
            Overtime / Tăng ca ( Select if shift is overtime / Chọn nếu địa điểm
            làm việc này thuộc tăng ca)
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item v-if="form.isOvertime">
          <SelectWorkOvertimeRate
            v-model="form.workOvertimeRateId"
            :selectProps="{
              value: form.workOvertimeRateId,
              placeholder: 'Select Rate',
            }"
            :initialDatas="form.workOvertimeRate ? [form.workOvertimeRate] : []"
            :isChooseFirst="true"
          />
        </a-form-model-item>
        <a-form-model-item label="Description / Mô tả">
          <VueEditor
            class="ict24h-editor"
            :editor-toolbar="customToolbar"
            placeholder="Enter description..."
            v-model="form.description"
          />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left"> Information </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Created by">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created at">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated at">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>

      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="Close"
          @confirm="onDeletedWorkShift"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close"> Close </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import SelectDepartment from "@/components/common/department/select";
import SelectBranchLocation from "@/components/common/branchLocation/select";
import SelectWorkOvertimeRate from "@/components/common/workOvertimeRate/select";
import query from "../constant/query";
import { dayOfWeeks } from "../constant/default";
import moment from "moment";

const rules = {
  title: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
};
export default {
  components: {
    SelectDepartment,
    SelectBranchLocation,
    SelectWorkOvertimeRate,
  },
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idWorkShift: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dayOfWeeks,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
      loadingWorkOvertimeRate: false,
      workOvertimeRates: [],
    };
  },
  computed: {
    startTimeAndEndTimeAndDurationBreakTime() {
      return `${this.form.startTime}|${this.form.endTime}|${this.form.durationBreakTime}`;
    },
    startBreakTimeAndDurationBreakTime() {
      return `${this.form.startBreakTime}|${this.form.durationBreakTime}`;
    },
  },
  watch: {
    startTimeAndEndTimeAndDurationBreakTime() {
      if (
        this.form.startTime &&
        this.form.endTime &&
        +this.form.durationBreakTime >= 0
      ) {
        const startTimeHour =
          moment(this.form.startTime).hour() +
          moment(this.form.startTime).minute() / 60;
        const endTimeHour =
          moment(this.form.endTime).hour() +
          moment(this.form.endTime).minute() / 60;

        if (startTimeHour > endTimeHour) {
          this.$set(
            this.form,
            "duration",
            24 - startTimeHour + endTimeHour - this.form.durationBreakTime
          );
        } else if (startTimeHour === endTimeHour) {
          this.$set(this.form, "duration", 24);
        } else {
          this.$set(
            this.form,
            "duration",
            endTimeHour - startTimeHour - this.form.durationBreakTime
          );
        }
      }
    },
    startBreakTimeAndDurationBreakTime() {
      if (this.form.startBreakTime && this.form.durationBreakTime) {
        this.$set(
          this.form,
          "endBreakTime",
          moment(this.form.startBreakTime).add(
            this.form.durationBreakTime,
            "hour"
          )
        );
      }
    },
  },
  created() {
    this.onGetWorkShift();
  },
  methods: {
    moment,
    onGetAllWorkOvertimeRate() {
      this.loadingWorkOvertimeRate = false;
      this.$apollo
        .query({
          query: query.getAllWorkOvertimeRate,
        })
        .then(({ data }) => {
          if (data?.getAllWorkOvertimeRate?.length >= 0) {
            this.workOvertimeRates = [...data.getAllWorkOvertimeRate];
          }
          this.loadingWorkOvertimeRate = false;
        })
        .catch((err) => {
          this.loadingWorkOvertimeRate = false;
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Lấy danh sách không thành công", err);
        });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedWorkShift();
        } else {
          return false;
        }
      });
    },
    onUpdatedWorkShift() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateWorkShift,
          variables: {
            id: this.form.id,
            code: this.form.code,
            title: this.form.title,
            dayInWeeks: this.form.dayInWeeks
              ? JSON.stringify(this.form.dayInWeeks)
              : undefined,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            duration: this.form.duration ? +this.form.duration : undefined,
            coefficient: this.form.coefficient
              ? +this.form.coefficient
              : undefined,
            isOvertime: this.form.isOvertime,
            description: this.form.description,
            departmentIds: this.form.departmentIds,
            branchLocationId: this.form.branchLocationId,
            startBreakTime: this.form.startBreakTime,
            endBreakTime: this.form.endBreakTime,
            makePayrollDate: this.form.makePayrollDate,
            workOvertimeRateId: this.form.isOvertime
              ? this.form.workOvertimeRateId
              : null,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
          if (data?.updateWorkShift?.id) {
            this.refreshAfterUpdated(data.updateWorkShift);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật địa điểm làm việc không thành công", err);
        });
    },
    onGetWorkShift() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getWorkShift,
          variables: { id: this.idWorkShift },
        })
        .then(({ data }) => {
          if (data?.getWorkShift?.id) {
            this.form = {
              ...data.getWorkShift,
              branchLocationId: data.getWorkShift.branchLocationId || undefined,
              dayInWeeks: data.getWorkShift.dayInWeeks
                ? JSON.parse(data.getWorkShift.dayInWeeks)
                : [],
              departmentIds:
                data.getWorkShift?.departments?.length > 0
                  ? data.getWorkShift.departments.map((e) => e.id)
                  : [],
              durationBreakTime:
                data.getWorkShift.startBreakTime &&
                data.getWorkShift.endBreakTime
                  ? moment(data.getWorkShift.endBreakTime).hour() +
                    moment(data.getWorkShift.endBreakTime).minute() / 60 -
                    (moment(data.getWorkShift.startBreakTime).hour() +
                      moment(data.getWorkShift.startBreakTime).minute() / 60)
                  : 0,
              makePayrollDate: +data.getWorkShift.makePayrollDate || undefined,
              workOvertimeRateId:
                data.getWorkShift.workOvertimeRateId || undefined,
            };
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Lấy chi tiết địa điểm làm việc không thành công", err);
        });
    },
    onDeletedWorkShift() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteWorkShift,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Updated Success!",
            });
            this.loadingBtn = false;
            if (data?.deleteWorkShift?.id) {
              this.refreshAfterDeleted(data.deleteWorkShift);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Updated Error!",
            });
            console.log("Xóa địa điểm làm việc không thành công", err);
          });
      }
    },
    calDurationTime() {
      // if (this.form.startTime && this.form.endTime) {
      //   const startTime = { ...moment(this.form.startTime).set({ second: 0 }) };
      //   const endTime = { ...moment(this.form.endTime).set({ second: 0 }) };
      //   if (
      //     startTime.hour() + startTime.minute() / 60 >
      //     endTime.hour() + endTime.minute()
      //   ) {
      //     this.$set(
      //       this.form,
      //       "duration",
      //       24 -
      //         (startTime.hour() + startTime.minute() / 60) -
      //         (endTime.hour() + endTime.minute() / 60)
      //     );
      //   } else if (
      //     startTime.hour() + startTime.minute() / 60 ===
      //     endTime.hour() + endTime.minute() / 60
      //   ) {
      //     this.$set(this.form, "duration", 24);
      //   } else {
      //     this.$set(
      //       this.form,
      //       "duration",
      //       endTime.diff(startTime, "minutes") / 60
      //     );
      //   }
      //   console.log("ahihi", this.form);
      // }
    },
    disabledHoursStartBreakTime() {
      let disabledHours = [];
      if (this.form?.startTime && this.form.endTime) {
        const startHour =
          new Date(this.form.startTime).getHours() +
          new Date(this.form.startTime).getMinutes() / 60;
        const endHour =
          new Date(this.form.endTime).getHours() +
          new Date(this.form.endTime).getMinutes() / 60;

        if (startHour > endHour) {
          for (let i = 0; i < 24; i += 0.5) {
            if (!(i > startHour || i < endHour)) {
              disabledHours.push(i);
            }
          }
        } else if (startHour < endHour) {
          for (let i = 0; i < 24; i += 0.5) {
            if (!(i > startHour && i < endHour)) {
              disabledHours.push(i);
            }
          }
        }
      }
      return disabledHours;
    },
    resetTime(flag) {
      if (flag === "startTime" || flag === "endTime") {
        this.form = {
          ...this.form,
          startBreakTime: null,
          durationBreakTime: 0,
          endBreakTime: null,
        };
      } else if (flag === "startBreakTime") {
        this.form = { ...this.form, durationBreakTime: 0, endBreakTime: null };
      }
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
